import React from "react";
import styled from "styled-components";
import KnowJesusCard from "../../cards/KnowJesusCard";

export default function KnowJesusSection({ data }) {
	return (
		<Section>
			<ul>
				{data?.map((dat) => (
					<KnowJesusCard data={dat} />
				))}
			</ul>
		</Section>
	);
}

const Section = styled.section``;
